// extracted by mini-css-extract-plugin
export default {"container":"UserHoldingsHolder_container__5qcHX","investProcess":"UserHoldingsHolder_investProcess__U4wp6","assetInvestStats":"UserHoldingsHolder_assetInvestStats__cU+67"};